import { render, staticRenderFns } from "./veStuCheckModify.vue?vue&type=template&id=2aee075f&scoped=true"
import script from "./veStuCheckModify.vue?vue&type=script&lang=js"
export * from "./veStuCheckModify.vue?vue&type=script&lang=js"
import style0 from "./veStuCheckModify.vue?vue&type=style&index=0&id=2aee075f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee075f",
  null
  
)

export default component.exports